import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { id: "pm2-lnb_ha" }
const _hoisted_5 = { class: "dep1" }

import BoardNavbar from "@/views/product/coaching/Navbar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'Business',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "기관신청",
      subtitle: "기관신청",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("기관신청"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Price.Org.Test.Path}`
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("검사 및 상담코칭 ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Price.Org.Activity.Path}`
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Activity ")
                ])),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).Price.Org.Expert.Path}`
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("전문가 교육 ")
                ])),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})